import { render, staticRenderFns } from "./SubProcNode.vue?vue&type=template&id=3cbe8932&scoped=true"
import script from "./SubProcNode.vue?vue&type=script&lang=js"
export * from "./SubProcNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbe8932",
  null
  
)

export default component.exports